import type { LicenseDetails } from "#shared/types/core/external/license";

export function useLicenses(
  predicate: (details: LicenseDetails) => boolean = () => true,
) {
  const api = useLicensesApi();

  const auth = useAuthorizeStore();

  return useQuery({
    queryKey: [auth.user?.selectedOrganization?.number, auth.user?.userId, "licenses"],
    enabled: auth.loggedIn,
    queryFn: () => api.getLicenseDetails(),
    select: (data) => data?.filter(predicate) ?? [],
  });
}
